import { FC, useContext, useMemo } from 'react';

import { Button, Dropdown, type MenuProps } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

import {
  GenericDataFormContext,
  QuotationInfoContext,
  QuotationStep,
} from '../../../../../../../shared';

import { StepTwoFormContext } from '../../../../contexts/StepTwoForm/StepTwoFormContext';

import './index.css';

interface HeaderTabCivilProps {
  id: number;
  areTabActionsAllowed: boolean;
}

export const HeaderTabCivil: FC<HeaderTabCivilProps> = ({
  id,
  areTabActionsAllowed,
}) => {
  const { tabs, setKeyTabToDelete, setShowModal } =
    useContext(StepTwoFormContext);
  const { currentStep } = useContext(QuotationInfoContext);
  const { userCanDeleteTabs } = useContext(GenericDataFormContext);

  const canNotDeleteTab = useMemo(() => tabs.length === 1 || !userCanDeleteTabs, [tabs, userCanDeleteTabs]);

  const onMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '2') {
      setKeyTabToDelete(id);
      setShowModal(true);
    }
  };

  const items = [
    {
      key: '2',
      label: 'Eliminar',
      danger: true,
      disabled: canNotDeleteTab,
    },
  ];

  return (
    <>
      Resp. Civil {id}
      {currentStep === QuotationStep.TWO && areTabActionsAllowed && (
        <Dropdown
          menu={{ items, onClick: onMenuClick }}
          trigger={['click']}
          arrow
        >
          <Button type='text' className='header-tab-civil-button'>
            <MoreOutlined />
          </Button>
        </Dropdown>
      )}
    </>
  );
};
